import { render } from "./UsersPage.vue?vue&type=template&id=930cb480&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"

import "./UsersPage.vue?vue&type=style&index=0&id=930cb480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930cb480"]])

export default __exports__